<div class="row m-0 p-0 bg-white shadow-sm h-100" style="min-height: 120vh;" >
  @if (showHistory) {
    <div class="col-12 col-sm-4 col-md-3 cursor-pointer m-0 p-0" id="scrollTestLab" scroll-directive
      (onScroll)="onScrollList($event)">
      <div class="p-1" style="text-align: center;">
        <button type="button" [attr.disabled]="_currentPage == 0 ? '' : null"
          class="pull-left btn btn-outline-primary btn-sm" (click)="goPrev()"><i class="fa fa-arrow-left"
        aria-hidden="true"></i></button>
        <button type="button" class="pull-right btn btn-outline-primary btn-sm"
          [attr.disabled]="getClassToEnableDisableIcon()" (click)="goNext()"><i class="fa fa-arrow-right"
        aria-hidden="true"></i></button>
        <h4>
          History ({{listCount?listCount:0}})
        </h4>
      </div>
      @for (list of sideListData; track list; let i = $index) {
        <div class="border p-3 doc-view-list" id="labtestList{{list.id}}"
          [ngClass]="{'doc-active-tab': i==0?true:false}" (click)="onClickSideList(list,$event,i)">
          @if (sideListData && sideListData.length>0) {
            <div class="row">
              @if (list.folder_name) {
                <div class="col-10">
                  <span class="text-primary font-weight-bold">{{list.folder_name | titlecase}}</span><br>
                </div>
              }
              @if (list.ownerName) {
                <div class="col-10">
                  <span class="text-primary font-weight-bold">{{list.ownerName | titlecase}}</span><br>
                </div>
              }
              @if (searchType != 'kyc') {
                <span (click)="deleteDocument(list)"><i class="fa fa-trash-o"
                style="color: red;cursor: pointer;"></i></span>
              }
            </div>
          }
          @if (sideListData && sideListData.length>0 && list.description) {
            <span> <b>Description :</b>
          {{list.description}} </span>
          }<br>
          <!-- <span *ngIf="sideListData && sideListData.length>0 && list.metadata != ''">  {{list.metadata}} </span><br> -->
          @if (sideListData && sideListData.length>0) {
            <span> <b>Date :</b> {{list.g_creation_time | dateTimeFormat}}
          </span>
        }
      </div>
    }
  </div>
}
<div class="border fullwidthviewer" id="scrollsTestLab" [class]="showHistory?'col-12 col-sm-8 col-md-9':'col-12'">
  @if (show_TypeDD_arrow) {
    <div class="row d-flex mt-2 _doc-header mobile-arrow-alignment">
      <div class="col-2">
        @if (multiDocumentId != undefined && multiDocumentId.length > 1) {
          <button id="arrow"
            class="btn btn-white cursor-pointer fa fa-arrow-left fa-lg butoon-small "
            style="color:rgb(82, 79, 79); font-family: 'FontAwesome';" (click)="getDocumentId('left')"
          [disabled]="(index == 0) ? true : false"></button>
        }
      </div>
      @if (config.showTypeDropdown) {
        <div class="col-lg-8 col-md-8 col-sm-8 col-12 pt-1 border cursor-pointer">
          <select class="form-control" (change)="valueChange($event.target.value)" [(ngModel)]="searchType">
            <option value="">--Select Type--</option>
            <option value='kyc'>KYC</option>
            <option value="clinical">Clinical</option>
          </select>
        </div>
      }
      <div class="col-2">
        @if (multiDocumentId != undefined && multiDocumentId.length > 1) {
          <button id="arrow" class="btn btn-white fa fa-arrow-right cursor-pointer fa-lg butoon-small float-right"
            style="color:rgb(82, 79, 79); font-family: 'FontAwesome';"
            (click)="getDocumentId('right')"
          [disabled]="(multiDocumentId != undefined && index == (multiDocumentId.length - 1)) ? true : false"></button>
        }
      </div>
    </div>
  }
  <hr>
    <ng-container [ngTemplateOutlet]="imageviewer">
    </ng-container>
  </div>
</div>

<!-- <div class="row" *ngIf="!rolePermissionService.checkAccessPermission('get', resourceName)">
<div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center my-auto">
  <div class="card card-block d-flex" style="height: 120px">
    <div class="card-body align-items-center d-flex justify-content-center font-xl">
      You don't have permission to view history...
    </div>
  </div>
</div>
</div> -->

<ng-template #imageviewer>
  <div class="row " style="height: calc(100% - 50px);">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 fullwidthviewer">
      <ng-container>
        @if (imageSrc.length > 0 && blobResp && (blobResp.type == 'image/jpeg' || blobResp.type == 'image/png' || blobResp.type == 'image/jpg' || blobResp.type == 'image/gif')) {
          <div
            >
            <app-image-viewer style="width: 100%; height:600px" [src]="imageSrc" [fileData]="fileData">
            </app-image-viewer>
          </div>
        }
        @if (pdfDocument && blobResp && blobResp.type == 'application/pdf') {
          <div class="h-100">
            <pdf-viewer [config]="pdfDocument" [isBlob]="true"></pdf-viewer>
          </div>
        }
        @if (blobResp && blobResp.type == 'text/plain') {
          <div>
            <div>
              <div style="margin-bottom: 1rem; font-weight: bold;">{{textFile.document_name ?
              textFile.document_name : ''}}</div>
              <div>{{decodedText ? decodedText : ''}}</div>
            </div>
          </div>
        }
        @if (blobResp && blobResp.type == 'application/dicom' && imageUrl != '') {
          <div>
            <diacom-viewer [config]="{url:imageUrl}"></diacom-viewer>
          </div>
        }
      </ng-container>
      @if (sideListData.length == 0 && imageSrc.length == 0 && !blobResp) {
        <div class="no-record-found">
          <div class="no-record-found-img-container">
            <img src="assets/images/nodata-icon.svg" class="no-records-found"/>
            <div class="no-records-found-text">
              <span >{{'field.label.no_records_found' | translate | async}}</span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>